/**
 * THE ACCOUNT ENUMS ON `UserObj`, READ OFF THE DOCUMENT RATHER THAN COPIED.
 *
 * SwaggerHub `Last-Modified` 27-09-2026 14:24 UTC enumerates `status`
 * (`A`/`I`), `displayLang` (`EN`/`ZH`) and `screenLayout`
 * (`BROWSER`/`WINGRID`). `displayLang` and `screenLayout` are the same unions
 * `PUT /v1/user/preference` already wrote. A hand-copied union keeps compiling
 * after the backend adds a value; the compile-time equality checks do not.
 */
import { z } from "zod";
import type { components } from "./generated/pharmos-api";
import type { DisplayLang, ScreenLayout } from "./preference";

type UserObj = components["schemas"]["UserObj"];

export const ACCOUNT_STATUSES = ["A", "I"] as const;
export const DISPLAY_LANGS = ["EN", "ZH"] as const;
export const SCREEN_LAYOUTS = ["BROWSER", "WINGRID"] as const;

type Equal<Contract, Listed extends string> = [Contract] extends [Listed]
  ? [Listed] extends [Contract]
    ? true
    : never
  : never;

/** Fails the build when a listed enum drifts from `UserObj` or the preference write. */
export const accountStatusMatches = true satisfies Equal<
  UserObj["status"],
  (typeof ACCOUNT_STATUSES)[number]
>;
export const displayLangMatches = true satisfies Equal<
  UserObj["displayLang"],
  (typeof DISPLAY_LANGS)[number]
> satisfies Equal<DisplayLang, (typeof DISPLAY_LANGS)[number]>;
export const screenLayoutMatches = true satisfies Equal<
  UserObj["screenLayout"],
  (typeof SCREEN_LAYOUTS)[number]
> satisfies Equal<ScreenLayout, (typeof SCREEN_LAYOUTS)[number]>;

export const accountStatusSchema = z.enum(ACCOUNT_STATUSES);
export const displayLangSchema = z.enum(DISPLAY_LANGS);
export const screenLayoutSchema = z.enum(SCREEN_LAYOUTS);
